<template>
  <div class="tenat_search">
    <b-form @submit="search">
      <b-input-group>
        <b-input :placeholder="$t('system.tenant_name_or_room_number')" v-model="search_term"/>
        <b-input-group-append>
          <b-button type="submit">
            <font-awesome-icon :icon="['fas', 'search']"></font-awesome-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
    <b-table responsive :items="search_results" :fields="extended_view?search_table_fields_extended:search_table_fields">
      <template v-slot:cell(name)="data">
        {{ data.item.bewohner.firstname }} {{ data.item.bewohner.lastname }}
      </template>
      <template v-slot:cell(room)="data">
        {{ data.item.bewohner.zimmer.hausnummer.hausnummer }}
        {{ data.item.bewohner.zimmer.zimmer }}
      </template>
      <template v-slot:cell(username)="data">
        <span v-if="data.item.user.username">{{ data.item.user.username }}</span>
        <span v-else><i>Account nicht aktiviert</i></span>
      </template>
      <template v-slot:cell(email)="data">
        <span v-if="data.item.user.email">{{ data.item.user.email }}</span>
        <span v-else><i>Account nicht aktiviert</i></span>
      </template>
      <template v-slot:cell(actions)="data">
        <b-button @click="assign_function(data.item)">{{ $t(action_label) }}</b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "TenantSearch",
  data() {
    return {
      search_term: '',
      search_results: [],
      search_table_fields: [
        {
          label: this.$t('system.name'),
          key: 'name'
        },
        {
          label: this.$t('system.room'),
          key: 'room'
        },
        {
          label: this.$t('system.actions'),
          key: 'actions',
        },
      ],
      search_table_fields_extended: [
        {
          label: this.$t('system.name'),
          key: 'name'
        },
        {
          label: this.$t('system.room'),
          key: 'room'
        },
        {
          label: this.$t('system.room'),
          key: 'room'
        },
        {
          label: this.$t('system.username'),
          key: 'username'
        },
        {
          label: this.$t('system.email'),
          key: 'email'
        },
        {
          label: this.$t('system.actions'),
          key: 'actions',
        },
      ],
    }
  },
  props: {
    action_label: {
      type: String,
      required: true
    },
    search_function: {
      type: Function,
      required: true
    },
    assign_function: {
      type: Function,
      required: true
    },
    extended_view: {
      type: Boolean,
      required: true,
      default() {
        return false
      }
    }
  },
  methods: {
    async search(ev) {
      ev.preventDefault()
      this.search_results = await this.search_function(this.search_term)
    }
  }
}
</script>

<style scoped>

</style>
